module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('fieldset', [_c('legend'), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors['name']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.product.name),
      callback: function($$v) {
        _vm.product.name = $$v
      },
      expression: "product.name"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Odmiana",
      "error": _vm.errors['variety']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.product.variety),
      callback: function($$v) {
        _vm.product.variety = $$v
      },
      expression: "product.variety"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Pochodzenie",
      "error": _vm.errors['origin']
    }
  }, [_c('select-input', {
    attrs: {
      "options": _vm.originOptions
    },
    model: {
      value: (_vm.product.origin),
      callback: function($$v) {
        _vm.product.origin = $$v
      },
      expression: "product.origin"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Jednostka",
      "error": _vm.errors['unit']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.product.unit),
      callback: function($$v) {
        _vm.product.unit = $$v
      },
      expression: "product.unit"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    attrs: {
      "submitting": _vm.submitting
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4788500b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductAddEdit.vue
// module id = 444
// module chunks = 1